/* Universal Event Tracking */
var Pixel = Pixel || {};

Pixel.UET = (function (PixelBase) {
    var UET = PixelBase.extend({
        initialize: function (opts) {

        },

        pageView: function () {

        },

        purchaseSuccess: function (opts) {
            opts = opts || {};
            var data = opts.OrderInfoResult;
            if (window.uetq && window.uetq.push) {
                window.uetq.push('event', 'purchase', { "revenue_value": data.Total, "currency": "AUD" });
            }
        }
    });

    return UET;
})(Pixel.PixelBase);

!function (Pixel, GlobalSettings) {
    //if (!GlobalSettings.CAE) {
    //    return;
    //}

    //(function (i, s, o, g, r, a, m) {
    //    i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
    //        (i[r].q = i[r].q || []).push(arguments)
    //    }, i[r].l = 1 * new Date(); a = s.createElement(o),
    //        m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
    //})(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

    new Pixel.UET();
}(Pixel, GlobalSettings);
